import { createWorld } from "@latticexyz/recs";

export const world = createWorld();
